import { useEffect, useState } from "react";

export const useCssVarLogoUrl = () => {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    const rawLogoUrl = getComputedStyle(document.documentElement)
      .getPropertyValue("--logo-url")
      .trim();
    if (!rawLogoUrl) return setUrl(null);

    // Support both: "/assets/logos/..." and "url("/assets/logos/...")"
    const parsed = rawLogoUrl.startsWith("url(")
      ? rawLogoUrl.replace(/^url\((.*)\)$/i, "$1").replace(/^["']|["']$/g, "")
      : rawLogoUrl;

    setUrl(parsed);
  }, []);

  return url;
};
